/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3RTBCreativeMapping } from '../models/V3RTBCreativeMapping';
import { HttpFile } from '../http/http';

/**
* A map of all creative ids on the order line to their RTB creative ids. RTB creatives belong to exactly one order line, so the same internal creative deployed to two order lines has a distinct external id in each one's map.
*/
export class V3RTBCreativeMap {
    /**
    * Creative id mappings for this order line.
    */
    'creatives'?: Array<V3RTBCreativeMapping>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "creatives",
            "baseName": "creatives",
            "type": "Array<V3RTBCreativeMapping>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3RTBCreativeMap.attributeTypeMap;
    }

    public constructor() {
    }
}

